export function isWidgetPromptLocked(agentChat, submissionPending = false) {
  return agentChat?.kind === 'widget' && submissionPending;
}

export function beginAgentChatSubmission(submissions, submission) {
  const next = new Map(submissions);
  next.set(submission.sequence, submission);
  return next;
}

export function settleAgentChatSubmission(submissions, sequence, submittedRequest) {
  if (!submissions.has(sequence)) return submissions;

  const next = new Map(submissions);
  if (submittedRequest) {
    next.set(sequence, submittedRequest);

    // Once a submission succeeds, every earlier client submission has been
    // superseded. Keep later pending submissions so a failure can reveal this one.
    for (const pendingSequence of next.keys()) {
      if (pendingSequence < sequence) next.delete(pendingSequence);
    }
  } else {
    next.delete(sequence);
  }

  return next;
}

export function latestAgentChatSubmission(submissions) {
  let latest = null;
  for (const submission of submissions.values()) {
    if (!latest || submission.sequence > latest.sequence) latest = submission;
  }
  return latest;
}
